import withParams from "@src/components/widgets/HOC/withParams";
import React, { useCallback } from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetHeaderAdrienCachotParams } from "../interface";
import LandingHeaderVideoAdrienCachot from "design-system/src/Components/WidgetPart/LandingHeaderVideoAdrienCachot/LandingHeaderVideoAdrienCachot";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";
import { responsiveMap } from "design-system/src/Components/Grid/_utils/responsiveObserve";
import { scrollToNextLandingBlock } from "../scrollToNextLandingBlock";

const HeaderAdrienCachot: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetHeaderAdrienCachotParams>((props) => {
    const { p } = props;
    const posterDesktop = p("poster_desktop");
    const posterMobile = p("poster_mobile");
    const displaySignature = p("display_signature") === "1";
    const { app } = useBackboneContext();

    const scrollToNextBlock = useCallback(() => {
      scrollToNextLandingBlock(
        '.widget-instance[data-template="header-adrien-cachot"]'
      );
    }, []);

    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html: `
            @media ${responsiveMap.mobile} {
              .widget-collection.is-page .widget-layout-0 .widget-instance[data-template="header-adrien-cachot"] {
                padding-top: 0 !important;
              }
            }
            `,
          }}
        />
        <LandingHeaderVideoAdrienCachot
          title={p("title") || "Sushi Shop"}
          posterDesktopId={posterDesktop}
          posterMobileId={posterMobile}
          displaySignature={displaySignature}
          ctaLabel={p("cta_label")}
          onClick={() => {
            app.go("listing");
          }}
          onScrollHintClick={scrollToNextBlock}
        />
      </>
    );
  });

export default HeaderAdrienCachot;
